import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import UserSessionContext from 'context/UserSessionContext';
import LoadingSpinner from 'components/LoadingSpinner';

function RestrictedRoute({ component: Component, ...rest }) {
  const { session } = useContext(UserSessionContext);
  const { isUserStateLoading, isLoggedIn } = session;

  if (isUserStateLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (isLoggedIn) {
          return <Component {...props} />;
        }
        return <Redirect to="/login" />;
      }}
    />
  );
}
RestrictedRoute.propTypes = {
  component: PropTypes.elementType
};

RestrictedRoute.defaultProps = {
  component: null
};

export default RestrictedRoute;
